// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"b8a547e7","488":"140f568a","605":"5be30232","943":"874f6fd8"}[chunkId] + ".chunk.js";
};